/**
 * @flow
 * @relayHash c90618dada60742620e380f897a748bc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StreamList_viewer$ref = any;
export type StreamList_Refetch_QueryVariables = {|
  page: number,
  search?: ?string,
  states?: ?$ReadOnlyArray<?string>,
|};
export type StreamList_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: StreamList_viewer$ref
  |}
|};
export type StreamList_Refetch_Query = {|
  variables: StreamList_Refetch_QueryVariables,
  response: StreamList_Refetch_QueryResponse,
|};
*/


/*
query StreamList_Refetch_Query(
  $page: Int!
  $search: String
  $states: [String]
) {
  viewer {
    ...StreamList_viewer_4vb9e5
    id
  }
}

fragment StreamList_viewer_4vb9e5 on Viewer {
  streams: streamsPaginate(pageSize: 10, page: $page, search: $search, states: $states) {
    totalCount
    streams {
      ...StreamListItem_stream
      id
    }
  }
}

fragment StreamListItem_stream on Stream {
  id
  title
  state
  availableAt
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "StreamList_Refetch_Query",
  "id": null,
  "text": "query StreamList_Refetch_Query(\n  $page: Int!\n  $search: String\n  $states: [String]\n) {\n  viewer {\n    ...StreamList_viewer_4vb9e5\n    id\n  }\n}\n\nfragment StreamList_viewer_4vb9e5 on Viewer {\n  streams: streamsPaginate(pageSize: 10, page: $page, search: $search, states: $states) {\n    totalCount\n    streams {\n      ...StreamListItem_stream\n      id\n    }\n  }\n}\n\nfragment StreamListItem_stream on Stream {\n  id\n  title\n  state\n  availableAt\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "StreamList_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StreamList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StreamList_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "streams",
            "name": "streamsPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 10,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[String]"
              }
            ],
            "concreteType": "StreamsPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "streams",
                "storageKey": null,
                "args": null,
                "concreteType": "Stream",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c85596f720b5032950230650b95ac5db';
module.exports = node;



// WEBPACK FOOTER //
// src/components/streams/__generated__/StreamList_Refetch_Query.graphql.js